import generateV3ActivityFilters from './activities';
import generateV3MyActivityFilters from './myActivity';

/**
 * Map of available V3 query filters.
 */
export var ACTIVITY_FILTER_V3_MAP = new Map([['myActivity', generateV3MyActivityFilters], ['activities', generateV3ActivityFilters]]);